// Soundslice notation layout documentation
// @link https://www.soundslice.com/help/en/embedding/javascript-api/40/notation/
// @link https://www.soundslice.com/help/en/player/advanced/241/scrollable-vs-paged-layout/

// The fluid layout (value 1) has several effects:
// 1. Automatically adjusts the stave width based on available space
// 2. Disables the “Respect line breaks” setting (only accessible through the Soundslice settings panel)
// 3. Ensures vertical scrolling layout
// For additional context:
// @link https://github.com/PlaygroundSessions/playground-web/pull/841

export enum NotationLayoutEnum {
  vertical=1, // Fluid
  // vertical=4, // Vertical scrolling
  horizontal=2,
  paged=5,
  auto=99 // 'Auto' scrolling is a PlaygroundSessions concept. Soundslice does not support it. When interacting with Soundslice, 'auto' should be transformed into something else.
}